// @ts-strict-ignore
import { CertificationWarningBar } from "@clinic/shared/components/WarningBars/CertificationWarningBar/CertificationWarningBar";
import { StudentCredentialsWarningBar } from "@clinic/shared/components/WarningBars/StudentCredentialsWarningBar/StudentCredentialsWarningBar";
import { useModularOnboardingModalData } from "@clinic/shared/hooks/useModularOnboardingModalData/useModularOnboardingModalData";
import { useSonicAccountSetupExperiment } from "@clinic/shared/hooks/useSonicAccountSetupExperiment/useSonicAccountSetupExperiment";
import { StoreSetupSteps } from "@clinic/shared/types/StoreSetupSteps";
import { useCurrentPractitionerIsStudentQuery } from "@shared/data/queries/CurrentPractitionerIsStudentQuery/CurrentPractitionerIsStudent.query";
import type { StorePlatform } from "@shared/types/StorePlatform";

interface Props {
  storePlatform: StorePlatform;
}

const CertPendingReviewWrapper = ({ storePlatform }: Props) => {
  const { currentSetupPage } = useModularOnboardingModalData();
  const { data: isStudentData, loading: isStudentLoading } = useCurrentPractitionerIsStudentQuery();

  const isSonicAccountSetupExperiment = useSonicAccountSetupExperiment();

  const isStudent = isStudentData?.currentPractitioner?.properties?.isStudent;
  const isGradDateInFuture =
    isStudentData?.currentPractitioner?.properties?.isStudentGraduationDateInTheFuture;

  const isStoreComplete = currentSetupPage === StoreSetupSteps.COMPLETE;

  if (isStudentLoading) return null;

  if (isSonicAccountSetupExperiment) return null;

  if (isStudent) {
    return (
      <StudentCredentialsWarningBar
        isStoreComplete={isStoreComplete}
        isGradDateInFuture={isGradDateInFuture}
        storePlatform={storePlatform}
      />
    );
  }

  return (
    <CertificationWarningBar isStoreComplete={isStoreComplete} storePlatform={storePlatform} />
  );
};

export { CertPendingReviewWrapper };
